import { render, staticRenderFns } from "./nodeDialog.vue?vue&type=template&id=50d36ed2&scoped=true"
import script from "./nodeDialog.vue?vue&type=script&lang=js"
export * from "./nodeDialog.vue?vue&type=script&lang=js"
import style0 from "./nodeDialog.vue?vue&type=style&index=0&id=50d36ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d36ed2",
  null
  
)

export default component.exports